import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { CollapsibleToggleRow, CollapsibleBody } from './CollapsiblePanel.styles';

export default function CollapsiblePanel({
  open,
  onToggle,
  instructionText = 'Clica il pulsante per modificare dati precompilati',
  openLabel = 'Detagli',
  closedLabel = 'Apri Detagli',
  children,
}) {
  return (
    <>
      <CollapsibleToggleRow>
        <p>{instructionText}</p>
        <button type="button" onClick={onToggle} aria-expanded={open}>
          <span>{open ? openLabel : closedLabel}</span>
          <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
        </button>
      </CollapsibleToggleRow>
      <CollapsibleBody $open={open}>
        {/* `inert` keeps the collapsed content out of the tab order/a11y
            tree while it's still mounted (kept mounted so the collapse can
            animate both ways, and so react-hook-form field state isn't
            churned by mount/unmount). */}
        <div inert={!open}>{children}</div>
      </CollapsibleBody>
    </>
  );
}
